/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Sandboxshell_Releasestatus_Prepurchase3Inputs */

const id_components_sandboxshell_releasestatus_prepurchase3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Prepurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pre-pembelian`)
};

const ms_components_sandboxshell_releasestatus_prepurchase3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Prepurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pre-pembelian`)
};

const da_components_sandboxshell_releasestatus_prepurchase3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Prepurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forudbestilling`)
};

const de_components_sandboxshell_releasestatus_prepurchase3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Prepurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorabkauf`)
};

const en_us2_components_sandboxshell_releasestatus_prepurchase3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Prepurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pre-purchase`)
};

const es_es2_components_sandboxshell_releasestatus_prepurchase3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Prepurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reserva`)
};

const es_mx2_components_sandboxshell_releasestatus_prepurchase3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Prepurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pre-compra`)
};

const fil_components_sandboxshell_releasestatus_prepurchase3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Prepurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pre-purchase`)
};

const fr_components_sandboxshell_releasestatus_prepurchase3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Prepurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pré-commande`)
};

const it_components_sandboxshell_releasestatus_prepurchase3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Prepurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pre-acquisto`)
};

const hu_components_sandboxshell_releasestatus_prepurchase3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Prepurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Előrendelés`)
};

const nl_components_sandboxshell_releasestatus_prepurchase3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Prepurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vooraankoop`)
};

const no_components_sandboxshell_releasestatus_prepurchase3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Prepurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forhåndskjøp`)
};

const pl_components_sandboxshell_releasestatus_prepurchase3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Prepurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przedsprzedaż`)
};

const pt_br2_components_sandboxshell_releasestatus_prepurchase3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Prepurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pre-Purchase`)
};

const pt_components_sandboxshell_releasestatus_prepurchase3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Prepurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pré-compra`)
};

const ro_components_sandboxshell_releasestatus_prepurchase3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Prepurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precomandă`)
};

const fi_components_sandboxshell_releasestatus_prepurchase3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Prepurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ennakko-osto`)
};

const sv_components_sandboxshell_releasestatus_prepurchase3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Prepurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Förköp`)
};

const vi_components_sandboxshell_releasestatus_prepurchase3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Prepurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đặt trước`)
};

const tr_components_sandboxshell_releasestatus_prepurchase3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Prepurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ön satın alma`)
};

const cs_components_sandboxshell_releasestatus_prepurchase3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Prepurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Předobjednávka`)
};

const bg_components_sandboxshell_releasestatus_prepurchase3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Prepurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварителна покупка`)
};

const ru_components_sandboxshell_releasestatus_prepurchase3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Prepurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предзаказ`)
};

const uk_components_sandboxshell_releasestatus_prepurchase3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Prepurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Передзамовлення`)
};

const ar_components_sandboxshell_releasestatus_prepurchase3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Prepurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الطلب المسبق`)
};

const hi_components_sandboxshell_releasestatus_prepurchase3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Prepurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्री-परचेज़`)
};

const th_components_sandboxshell_releasestatus_prepurchase3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Prepurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สั่งซื้อล่วงหน้า`)
};

const ja_components_sandboxshell_releasestatus_prepurchase3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Prepurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`予約購入`)
};

const zh_cn2_components_sandboxshell_releasestatus_prepurchase3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Prepurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pre-Purchase`)
};

const zh_hant1_components_sandboxshell_releasestatus_prepurchase3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Prepurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pre-Purchase`)
};

const ko_components_sandboxshell_releasestatus_prepurchase3 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Prepurchase3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pre-Purchase`)
};

/**
* | output |
* | --- |
* | "Pre-purchase" |
*
* @param {Components_Sandboxshell_Releasestatus_Prepurchase3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_sandboxshell_releasestatus_prepurchase3 = /** @type {((inputs?: Components_Sandboxshell_Releasestatus_Prepurchase3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Sandboxshell_Releasestatus_Prepurchase3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_sandboxshell_releasestatus_prepurchase3(inputs)
	if (locale === "ms") return ms_components_sandboxshell_releasestatus_prepurchase3(inputs)
	if (locale === "da") return da_components_sandboxshell_releasestatus_prepurchase3(inputs)
	if (locale === "de") return de_components_sandboxshell_releasestatus_prepurchase3(inputs)
	if (locale === "en-US") return en_us2_components_sandboxshell_releasestatus_prepurchase3(inputs)
	if (locale === "es-ES") return es_es2_components_sandboxshell_releasestatus_prepurchase3(inputs)
	if (locale === "es-MX") return es_mx2_components_sandboxshell_releasestatus_prepurchase3(inputs)
	if (locale === "fil") return fil_components_sandboxshell_releasestatus_prepurchase3(inputs)
	if (locale === "fr") return fr_components_sandboxshell_releasestatus_prepurchase3(inputs)
	if (locale === "it") return it_components_sandboxshell_releasestatus_prepurchase3(inputs)
	if (locale === "hu") return hu_components_sandboxshell_releasestatus_prepurchase3(inputs)
	if (locale === "nl") return nl_components_sandboxshell_releasestatus_prepurchase3(inputs)
	if (locale === "no") return no_components_sandboxshell_releasestatus_prepurchase3(inputs)
	if (locale === "pl") return pl_components_sandboxshell_releasestatus_prepurchase3(inputs)
	if (locale === "pt-BR") return pt_br2_components_sandboxshell_releasestatus_prepurchase3(inputs)
	if (locale === "pt") return pt_components_sandboxshell_releasestatus_prepurchase3(inputs)
	if (locale === "ro") return ro_components_sandboxshell_releasestatus_prepurchase3(inputs)
	if (locale === "fi") return fi_components_sandboxshell_releasestatus_prepurchase3(inputs)
	if (locale === "sv") return sv_components_sandboxshell_releasestatus_prepurchase3(inputs)
	if (locale === "vi") return vi_components_sandboxshell_releasestatus_prepurchase3(inputs)
	if (locale === "tr") return tr_components_sandboxshell_releasestatus_prepurchase3(inputs)
	if (locale === "cs") return cs_components_sandboxshell_releasestatus_prepurchase3(inputs)
	if (locale === "bg") return bg_components_sandboxshell_releasestatus_prepurchase3(inputs)
	if (locale === "ru") return ru_components_sandboxshell_releasestatus_prepurchase3(inputs)
	if (locale === "uk") return uk_components_sandboxshell_releasestatus_prepurchase3(inputs)
	if (locale === "ar") return ar_components_sandboxshell_releasestatus_prepurchase3(inputs)
	if (locale === "hi") return hi_components_sandboxshell_releasestatus_prepurchase3(inputs)
	if (locale === "th") return th_components_sandboxshell_releasestatus_prepurchase3(inputs)
	if (locale === "ja") return ja_components_sandboxshell_releasestatus_prepurchase3(inputs)
	if (locale === "zh-CN") return zh_cn2_components_sandboxshell_releasestatus_prepurchase3(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_sandboxshell_releasestatus_prepurchase3(inputs)
	return ko_components_sandboxshell_releasestatus_prepurchase3(inputs)
});
export { components_sandboxshell_releasestatus_prepurchase3 as "components.sandboxShell.releaseStatus.prePurchase" }